import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Breadcrumb } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Colors } from "../../modules/Colors";
import { inherits } from "util";
import { PropsWithChildren } from "react";

interface IProps extends PropsWithChildren {
  items: BreadCrumbItem[];
  className?: string;
}

export class BreadCrumbItem {
  constructor(public text: string, public navTo: string, public active?: boolean, public icon?: IconProp, public title?: string, public color?: string) {}
}

const StickyBreadCrumb = ({ items, className, children }: IProps) => {
  const navigate = useNavigate();

  return (
    <div className={"StickyBreadcrumb align-items-center" + (className ? " " + className : "")}>
      <div className="row align-items-center m-0 p-0">
        <div className={children ? "col col-md-9" : ""} style={{ alignSelf: "center" }}>
          <Breadcrumb className="mb-2 mt-2 me-2" style={{ display: "inline-block" }}>
            {items.map((item, i) => (
              <Breadcrumb.Item
                onClick={() => {
                  navigate(item.navTo);
                }}
                key={i}
                active={item.active}
                title={item.title}
              >
                {item.icon ? <FontAwesomeIcon style={{ marginRight: 10, color: item.color }} icon={item.icon} /> : <></>}

                {item.text}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
        {children ? (
          <div className="col col-md-3 p-0 pe-lg-2" style={{ alignSelf: "center", display: "flex", justifyContent: "flex-end" }}>
            {children}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default StickyBreadCrumb;
